import type { TFunction } from "i18next";

import type { OrderScriptRow } from "../types/marketplace.types";
import { countOrderLineKinds } from "./order-line-kind";

export function formatOrderLineCount(
  rows: ReadonlyArray<Pick<OrderScriptRow, "briefId" | "customAssetKind">>,
  t: TFunction,
): string {
  const { scripts, briefs } = countOrderLineKinds(rows);
  const scriptLabel = t("marketplace.orders.scriptCount", { count: scripts });
  if (briefs === 0) return scriptLabel;
  const briefLabel = t("marketplace.orders.briefCount", {
    count: briefs,
    defaultValue_one: "{{count}} brief",
    defaultValue_other: "{{count}} briefs",
  });
  if (scripts === 0) return briefLabel;
  return t("marketplace.orders.mixedItemCount", {
    scripts: scriptLabel,
    briefs: briefLabel,
    defaultValue: "{{scripts}} · {{briefs}}",
  });
}
